import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

const resolveUrl = (url) =>
  url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export const VideoCarousel = () => {
  const [videos, setVideos] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {});
  }, []);

  if (videos.length === 0) return null;

  const scroll = (dir) =>
    scrollRef.current?.scrollBy({ left: dir * 300, behavior: "smooth" });

  return (
    <div data-testid="sobre-video-carousel" className="mt-10">
      <h3 className="font-serif text-2xl text-[#2C352D] mb-4">Vídeos</h3>
      <div className="relative">
        {videos.length > 1 && (
          <>
            <button
              data-testid="video-carousel-prev"
              onClick={() => scroll(-1)}
              aria-label="Vídeo anterior"
              className="absolute -left-4 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-2 soft-shadow border border-[#8BA88E]/20 text-[#2C352D] hover:bg-[#F5F5ED] transition-colors"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              data-testid="video-carousel-next"
              onClick={() => scroll(1)}
              aria-label="Próximo vídeo"
              className="absolute -right-4 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-2 soft-shadow border border-[#8BA88E]/20 text-[#2C352D] hover:bg-[#F5F5ED] transition-colors"
            >
              <ChevronRight size={20} />
            </button>
          </>
        )}
        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2 scrollbar-thin"
          style={{ scrollbarWidth: "thin" }}
        >
          {videos.map((v) => (
            <div
              key={v.id}
              data-testid={`video-item-${v.id}`}
              className="w-[250px] shrink-0 aspect-[9/16] rounded-2xl overflow-hidden bg-black snap-start soft-shadow"
            >
              {v.type === "upload" ? (
                <video
                  src={resolveUrl(v.url)}
                  controls
                  playsInline
                  preload="metadata"
                  className="w-full h-full object-contain bg-black"
                />
              ) : (
                <iframe
                  src={v.url}
                  title={`Vídeo ${v.type}`}
                  className="w-full h-full border-0"
                  allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                  allowFullScreen
                  loading="lazy"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
